import type { SurveyModel } from '../api/survey-model';

export interface Answer {
  question: string;
  questionUuid: string;
  answer: string;
  comment: string | null;
}

function getUuidByQuestionText(survey: SurveyModel, text: string): string {
  const found = survey.survey.content.questions.find((question) => question.text === text);
  if (found !== undefined) {
    return found.uuid;
  }

  return '';
}

/**
 * Creates an answer to be submitted for the Churn Survey.
 * It uses the text of the question directly to find its uuid.
 */
export function createAnswerFromQuestionText(
  question: string,
  answer: string,
  survey: SurveyModel,
): Answer {
  return {
    question,
    answer,
    questionUuid: getUuidByQuestionText(survey, question).substring(0, 8),
    comment: null,
  };
}

/**
 * Creates an answer to be submitted for the Churn Survey v2.
 * It uses the index of the question to find its uuid and text.
 */
export function createAnswerFromQuestionIndex(
  questionIndex: number,
  answer: string,
  survey: SurveyModel,
): Answer {
  const questionData = survey.survey.content.questions[questionIndex];
  return {
    question: questionData.text,
    answer,
    questionUuid: questionData.uuid.substring(0, 8),
    comment: null,
  };
}
